import { useModalStore } from '@/shared/ui/AppModal/store/modal';
import { SCROLL_LOCK_ALLOWED_SELECTORS } from '@/shared/constants/scrollLockConstants';

let savedHtmlOverflow = '';
let savedBodyPaddingRight = '';

const preventTouchMove = (event: TouchEvent): void => {
  const { target } = event;
  if (
    target instanceof Element &&
    SCROLL_LOCK_ALLOWED_SELECTORS.some((selector) => target.closest(selector))
  ) {
    return;
  }
  event.preventDefault();
};

const applyBodyScrollLock = (): void => {
  const html = document.documentElement;
  const { body } = document;
  const scrollbarWidth = window.innerWidth - html.clientWidth;

  savedHtmlOverflow = html.style.overflow;
  savedBodyPaddingRight = body.style.paddingRight;
  html.style.overflow = 'hidden';

  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`;
  }

  document.addEventListener('touchmove', preventTouchMove, { passive: false });
};

const releaseBodyScrollLock = (): void => {
  document.removeEventListener('touchmove', preventTouchMove);
  document.documentElement.style.overflow = savedHtmlOverflow;
  document.body.style.paddingRight = savedBodyPaddingRight;
};

export const setupBodyScrollLock = (): void => {
  const modalStore = useModalStore();

  watch(
    () => modalStore.isScrollLocked,
    (isLocked) => {
      if (isLocked) {
        applyBodyScrollLock();
      } else {
        releaseBodyScrollLock();
      }
    },
  );
};

export default defineNuxtPlugin({
  name: 'scroll-lock',
  setup: () => setupBodyScrollLock(),
});
